import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Table } from 'antd'

//
import getBalanceDetails from 'core/application/adminDashboard/reimbursements/perks/reimbursementsBalances/getBalanceDetails'

import { useQueryRequestV2 } from 'common/hooks'

import BalanceDetailsColumns from './BalanceDetailsColumns'

interface BalanceDetailsProps {
  companyUserId: string
  planPeriodId: string
  categoryId: number
}

const BalanceDetails: React.FC<BalanceDetailsProps> = ({ companyUserId, planPeriodId, categoryId }) => {
  const { t: translate } = useTranslation()
  const {
    data: balanceDetails,
    isLoading: isBalanceDetailsLoading,
    reload: reloadBenefitDetails,
  } = useQueryRequestV2({
    initialState: null,
    queryFn: () => getBalanceDetails(companyUserId, planPeriodId, categoryId),
  })
  useEffect(() => {
    reloadBenefitDetails()
  }, [planPeriodId])

  return (
    balanceDetails && (
      <Table
        //loading={isBalanceDetailsLoading}
        dataSource={balanceDetails}
        columns={BalanceDetailsColumns(translate)}
        pagination={false}
      />
    )
  )
}

export default BalanceDetails
